import { AgentNode } from './agent';
import { AudioNode } from './audio';
import { CodeNode } from './code';
import { DropNode } from './drop';
import { FileNode } from './file';
import { ImageNode } from './image';
import { LLMNode } from './llm';
import { MemoryNode } from './memory';
import { TextNode } from './text';
import { ToolNode } from './tool';
import { TweetNode } from './tweet';
import { VideoNode } from './video';

export const nodeTypes = {
  image: ImageNode,
  text: TextNode,
  drop: DropNode,
  video: VideoNode,
  audio: AudioNode,
  code: CodeNode,
  file: FileNode,
  tweet: TweetNode,
  agent: AgentNode,
  tool: ToolNode,
  llm: LLMNode,
  memory: MemoryNode,
};
